import { withInstall } from '../../../utils/with-install'
import PointLayer from './PointLayer.vue'

export const ElAmapLocaPoint = withInstall(PointLayer)
export default ElAmapLocaPoint
